const galleries = document.querySelectorAll<HTMLElement>(".gallery");

galleries.forEach((gallery) => {
    const big = gallery.querySelector<HTMLImageElement>(".big-image");
    const previews = gallery.querySelectorAll<HTMLImageElement>(".preview");

    previews.forEach((preview) => {
        preview.addEventListener("click", () => {
            big.src = preview.src;
            previews.forEach((p) => {
                p.classList.remove("current");
            });
            preview.classList.add("current");
            // we want to transition the height change so we need to set the height explicitly
            const ratio = big.width / Number(preview.getAttribute("width"));
            big.style.height = `${Number(preview.getAttribute("height")) * ratio}px`;
        });
    });
});
